export default __webpack_public_path__ + "static/media/not_found.7dc171fc.svg";